<template>
  <div id="scrollArea" class="clusterize-scroll">
    <div id="contentArea" class="clusterize-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Clusterize from 'clusterize.js'

export default {
  props: {
    data: {}
  },
  mounted () {
    var clusterize = new Clusterize({
      scrollId: 'scrollArea',
      contentId: 'contentArea',
      rows_in_block: 5
    });
    console.log(clusterize.getScrollProgress())
  }
}
</script>
